import { Grid } from '@mui/material';
import * as React from 'react';
import { FC } from 'react';
import CarSimProps from './Model/ICarSimOutputData';
import { CarSimResultComponent } from './CarSimResultComponent';
import { CarSimFormComponent } from './CarSimFormComponent';

import './css/normalize.css';
import './css/webflow.css';
import './css/webflow_carsim.css';
import './css/carsim.css';

interface CarSimComponentProps{
  openFeedback : boolean;
  setOpenFeedback : React.Dispatch<React.SetStateAction<boolean>>;
}

const CarSimComponent:FC<CarSimComponentProps> = (props) => {

  let tempSimData = new CarSimProps();

  const [myCarSimData, setMyCarSimData] = React.useState<CarSimProps>(tempSimData);
  const [myYearlyValue, setMyYearlyValue] = React.useState(0);

  function UpdateCarsimData(updatedCarSimData : CarSimProps, selectedYear : number)
  {
    setMyCarSimData(updatedCarSimData); 
    setMyYearlyValue(selectedYear);

    props.setOpenFeedback(true);
  }

  return (
    <>  
      <CarSimFormComponent updateData={(myData : CarSimProps, selectedYear : number) => UpdateCarsimData(myData, selectedYear)}/>
      <CarSimResultComponent carSimTableData={myCarSimData} selectedYear={myYearlyValue} />
    </>
  );
}

export default CarSimComponent;